/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ClientMessageType {
  ERROR = "ERROR",
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

/**
 * An enumeration.
 */
export enum EventPosterMode {
  HIDDEN = "HIDDEN",
  IMAGE = "IMAGE",
  VIDEO_EMBED = "VIDEO_EMBED",
}

/**
 * An enumeration.
 */
export enum EventStatus {
  ACTIVE = "ACTIVE",
  ARCHIVE = "ARCHIVE",
  DRAFT = "DRAFT",
}

/**
 * An enumeration.
 */
export enum SurveyQuestionType {
  FILL_BLANKS = "FILL_BLANKS",
  MULTIPLE_ANSWER = "MULTIPLE_ANSWER",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  MULTIPLE_CHOICE_DROPDOWN = "MULTIPLE_CHOICE_DROPDOWN",
  TEXT = "TEXT",
}

export interface AddressInput {
  city?: string | null;
  country?: string | null;
  state?: string | null;
  street?: string | null;
  street2?: string | null;
  zip?: string | null;
}

export interface ContactPromoterMessage {
  content: string;
  userEmail: string;
}

export interface EventAttendeeContactInput {
  city?: string | null;
  company?: string | null;
  country?: string | null;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string | null;
  salutation?: string | null;
  state?: string | null;
  street?: string | null;
  street2?: string | null;
  zip?: string | null;
}

export interface EventPurchaserContactInput {
  address?: AddressInput | null;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
}

export interface TicketClaimInput {
  attendee?: EventAttendeeContactInput | null;
  surveyResponses?: (TicketSurveyInput | null)[] | null;
}

export interface TicketSurveyInput {
  questionId: any;
  response: any;
}

export interface UpdateOrderInput {
  donationAmount?: any | null;
  purchaser?: EventPurchaserContactInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
